import { AccountItemEnum } from '../../../../../../../../../modules/mobile/modals/profile';

export default {
  title: 'Konto',
  items: {
    [AccountItemEnum.ManageAccount]: {
      title: 'Konto verwalten',
      description: 'Halte dein Konto auf dem neuesten Stand und verwalte deine Einstellungen.',
    },
    [AccountItemEnum.PaymentMethods]: {
      title: 'Zahlungsmethoden',
      description: 'Füge deine bevorzugte Zahlungsmethode hinzu, ändere sie oder wähle sie aus.',
    },
    [AccountItemEnum.HelpAndFAQs]: {
      title: 'Hilfe und FAQs',
    },
    [AccountItemEnum.Logout]: {
      title: 'Ausloggen',
    },
    [AccountItemEnum.Language]: {
      title: 'Sprache',
    },
  },
};
